import { Module, ModuleEnum } from "../../../constants";

export const MODULES: ModuleEnum[] = [
  Module.Analytics,
  Module.Reflection,
  Module.Solution,
];

export const ALLOWED_COMBINATIONS: ModuleEnum[][] = [
  [Module.Analytics, Module.Reflection, Module.Solution],
  [Module.Analytics],
  [Module.Analytics, Module.Reflection],
  [Module.Analytics, Module.Solution],
];
